import { Text, Image as ImageComponent, Box, Flex, Alert, AlertIcon } from '@chakra-ui/react';
import React, { useState } from 'react'
import { contactFaq } from '../data/faq';
import { WrapperStyle } from '../styles/newDesignStyles';
import { PrimaryButton } from "../components/button"
import Head from 'next/head';
import { useMutation } from 'react-query';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';
import { ContactInput, ContactTextArea } from '../components/UI/Forms/Input/Input'

const Contact_us = () => {

    const [messageStatus, setMessageStatus] = useState('idle')

    async function createLeadRequest(leadData) {
        setMessageStatus('loading');
        const response = await fetch("/api/contact-us", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ lead: leadData })
        })

        const data = await response.json();
        const { message } = data;
        return message;
    }

    const mutation = useMutation(createLeadRequest, {
        onError: (error) => {
            // An error happened!
            setMessageStatus('error')
            toast({
                title: "Error",
                description: `An error occured. Please email as us at hello@zonado.com instead.`,
                status: "error",
                duration: 9000,
                isClosable: true,
            })
        },

        onSuccess: (data, variables, context) => {
            if (data) {

                setMessageStatus('success');
            }

            else throw 'error'
        }
    })

    const MessageSchema = Yup.object().shape({
        message: Yup.string()
            .max(1000, 'Too long.')
            .required("A message is required."),

        email: Yup.string()
            .email('Invalid email.')
            .required('Email is required.'),

        phone: Yup.string()
            .min(10, 'Must be 10 digits long')
            .max(10, "Must be 10 digits long"),

        name: Yup.string()
            .min(2)
            .required('Name is required.'),
    });

    return (
        <>

            <Head>
                <title key="title">Contact us - Canadian Business and Commercial Real Estate Listings</title>
                <meta key="description" name="description" content="For any enquiries, reach out to the team at Zonado. Call, email or message on the website." />
                <meta key="og:title" property="og:title" content='Contact us - Canadian Business and Commercial Real Estate Listings' />
                <meta key="og:description" property="og:description" content="For any enquiries, reach out to the team at Zonado. Call, email or message on the website." />
                <link rel="canonical" href="https://zonado.com/contact-us" />
            </Head>


            <WrapperStyle>
                <Box my={{ base: "50px", lg: "120px" }}>
                    <Flex flexDir={{ base: "column", md: "row" }} w={"100%"} justifyContent={"space-between"} >
                        <Flex w={{ base: "100%", md: "40%" }} flexDir={"column"} >
                            <Text textAlign={{ base: "center", md: "start" }} fontSize={{ base: "34px", lg: "60px" }} lineHeight={{ base: "44px", lg: "66px" }} color={"brand.black"} fontWeight={"500"}>Contact Us</Text>
                            <Text textAlign={{ base: "center", md: "start" }} mt={{ base: "20px", lg: "30px" }} pb={"30px"} borderBottomWidth={{ base: "0", lg: "1px" }} color={"gray.500"} borderColor={"gray.200"} fontSize={{ md: "17px" }} lineHeight={{ md: "29px" }}>For questions concerning your listings, message us at newlisting@zonado.com</Text>

                            <Box display={{ base: "none", md: "block" }} my={{ base: "50px", md: "0" }}>
                                <Box mt={"50px"}>
                                    <Box display={"flex"}>
                                        <ImageComponent src={"/images/newLanding/sendEmail.svg"} width={"30px"} height={"30px"} mr={"20px"} />
                                        <Box>
                                            <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"}>Send us an email</Text>

                                            <a href={"mailto:support@zonado.com"}>
                                                <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"} color={"brand.900"}>support@zonado.com</Text>
                                            </a>

                                        </Box>
                                    </Box>
                                </Box>

                                <Box mt={{ base: "30px", lg: "50px" }}>
                                    <Box display={"flex"}>
                                        <ImageComponent src={"/images/newLanding/callIcon.svg"} width={"30px"} height={"30px"} mr={"20px"} />
                                        <Box>
                                            <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"}>Call us</Text>

                                            <a href={"tel:18856677308"}>
                                                <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"} color={"brand.900"} >1 (855) 667 7308</Text>
                                            </a>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box mt={{ base: "30px", lg: "50px" }}>
                                    <Box display={"flex"}>
                                        <ImageComponent src={"/images/newLanding/chatIcon.svg"} width={"30px"} height={"30px"} mr={"20px"} />
                                        <Box>
                                            <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"}>Chat with us</Text>
                                            <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"} color={"brand.900"} >Use chat below</Text>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                        </Flex>

                        <Formik
                            initialValues={{
                                name: '',
                                phone: '',
                                email: '',
                                company: '',
                                message: ''
                            }}

                            validationSchema={MessageSchema}

                            onSubmit={async (values, { setSubmitting }) => {

                                if (messageStatus !== 'loading') {
                                    mutation.mutate({
                                        ...values
                                    });

                                    setSubmitting(false);
                                }

                            }}>

                            {({ isSubmitting, isValid, handleChange, values, handleSubmit }) => (
                                <>
                                    {messageStatus !== 'success'
                                        &&
                                        <Flex w={{ md: "50%" }}>
                                            <form onSubmit={handleSubmit}>
                                                <Box shadow={"lg"} w={"100%"} p={"50px"} display={"flex"} flexWrap={"wrap"} justifyContent={"space-between"}>
                                                    <Field
                                                        type="text"
                                                        name="name"
                                                        id="name"
                                                        placeholder="Name"
                                                        component={ContactInput}
                                                        rounded={"28px"}
                                                    />

                                                    <Field
                                                        type="email"
                                                        name="email"
                                                        id="email"
                                                        placeholder="Email"
                                                        component={ContactInput}
                                                        rounded={"28px"}
                                                    />

                                                    <Field
                                                        type="number"
                                                        name="phone"
                                                        id="phone"
                                                        placeholder="Phone (optional)"
                                                        component={ContactInput}
                                                        rounded={"28px"}
                                                    />

                                                    <Field
                                                        type="text"
                                                        name="company"
                                                        id="company"
                                                        placeholder="Company (optional)"
                                                        component={ContactInput}
                                                        rounded={"28px"}
                                                    />

                                                    <Field
                                                        type="text"
                                                        name="message"
                                                        id="message"
                                                        placeholder="How can we help"
                                                        component={ContactTextArea}
                                                    />

                                                    <PrimaryButton
                                                        type="submit"
                                                        loading={messageStatus === 'loading'}
                                                        loadingText="Sending Message"
                                                        label={"Contact Us"}
                                                        mt={"28px"}
                                                        ml={{ base: "auto", lg: 0 }}
                                                        mr={"auto"}
                                                    />
                                                </Box>
                                            </form>
                                        </Flex>
                                    }

                                    {messageStatus === 'success' &&
                                        <Box>
                                            <Alert status="success" variant="solid">
                                                <AlertIcon />
                                                Thanks for reaching out! We'll be in touch soon
                                            </Alert>
                                        </Box>
                                    }


                                    {(messageStatus === 'error') &&
                                        <Message show error>
                                            There was an error, please try again later.
                                        </Message>
                                    }
                                </>
                            )}
                        </Formik>

                    </Flex>

                    <Box display={{ base: "block", md: "none" }}>
                        <Box mt={"50px"}>
                            <Box display={"flex"}>
                                <ImageComponent src={"/images/newLanding/sendEmail.svg"} width={"30px"} height={"30px"} mr={"20px"} />
                                <Box>
                                    <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"}>Send us an email</Text>

                                    <a href={"mailto:support@zonado.com"}>
                                        <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"} color={"brand.900"}>support@zonado.com</Text>
                                    </a>
                                </Box>
                            </Box>
                        </Box>

                        <Box mt={{ base: "30px", lg: "50px" }}>
                            <Box display={"flex"}>
                                <ImageComponent src={"/images/newLanding/callIcon.svg"} width={"30px"} height={"30px"} mr={"20px"} />
                                <Box>
                                    <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"}>Call us</Text>

                                    <a href={"tel:18856677308"}>
                                        <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"} color={"brand.900"} >1 (855) 667 7308</Text>
                                    </a>
                                </Box>
                            </Box>
                        </Box>

                        <Box mt={{ base: "30px", lg: "50px" }}>
                            <Box display={"flex"}>
                                <ImageComponent src={"/images/newLanding/chatIcon.svg"} width={"30px"} height={"30px"} mr={"20px"} />
                                <Box>
                                    <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"}>Chat with us</Text>
                                    <Text fontSize={{ md: "17px" }} lineHeight={{ md: "22px" }} fontWeight={"500"} color={"brand.900"} >Use chat below</Text>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </WrapperStyle>
        </ >
    )
}

Contact_us.newLayout = true;
Contact_us.faq = contactFaq;

export default Contact_us